<template>
  <el-dialog
      width="25%"
    :title="`${dialogAction} discount`"
    :visible.sync="modalState"
    :close-on-click-modal="true"
    :before-close="hideModalHandler"
    :destroy-on-close="true"
    >
    <div class="form-block">
      <el-form
          :model="form"
          :rules="validateRules"
          ref="addEditDiscountForm"
          class="discounts-form"
          label-position="left"
      >
        <el-form-item label="Name" prop="name">
          <el-input size="mini" autocomplete="off" v-model="form.name" />
        </el-form-item>

        <el-form-item label="Stripe ID" prop="code">
          <el-input size="mini" autocomplete="off" v-model="form.code" :disabled="dialogAction !== 'Add'" />
        </el-form-item>

        <el-form-item label="Percent Off" prop="percent_off">
          <el-input size="mini" autocomplete="off" v-model="form.percent_off" :disabled="dialogAction !== 'Add'"/>
        </el-form-item>

        <el-row type="flex" justify="center">
          <el-button
              :type="dialogAction === 'Add' ? 'success' : 'primary'"
              :icon="dialogAction === 'Add' ? 'mdi mdi-content-save' : 'mdi mdi-pencil'"
              plain
              size="mini"
              @click="handleSubmitForm"
          >
            {{ dialogAction === 'Add' ? 'Save' : 'Edit' }}
          </el-button>
        </el-row>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: 'DiscountAddEditDialog',
    props: {
      modalState: {
        type: Boolean,
        default: false,
        required: true
      },
      dialogAction: {
        type: String,
        required: true
      },
      discountId: Number || String,
    },
    data() {
      return {
        validateRules: {
          name: [{ required: true, message: 'Please input Discount name', trigger: 'blur' }],
          code: [{ required: true, message: 'Please input StripeID', trigger: 'blur' }],
          percent_off: [{ required: true, message: 'Please input Percent Off', trigger: 'blur' }]
        },
        form: {
          name: null,
          code: null,
          percent_off: null
        }
      }
    },
    computed: {
      ...mapGetters({
        discountData: 'discounts/getDiscountShow'
      })
    },
    watch: {
      discountData(val) {
        this.form = {...this.form, ...val}
      }
    },
    methods: {
      hideModalHandler() {
        this.$store.dispatch('discounts/clearCurrentDiscount')

        this.$emit('hide-modal')
      },
      handleSubmitForm() {
        this.$refs.addEditDiscountForm.validate(valid => {
          if (valid) {
            if (this.dialogAction === 'Add') {
              this.$store.dispatch('discounts/createDiscount', this.form)
                  .then(() => this.hideModalHandler())
            } else {
              this.$store.dispatch('discounts/updateDiscount', this.form)
                  .then(() => this.hideModalHandler())
            }
          } else {
            this.$message.error('Form not validated')

            return false
          }
        })
      }
    },
    created() {
      if (this.dialogAction === 'Add') {
        this.$store.dispatch('discounts/clearCurrentDiscount')
        this.form = { name: null, code: null, percent_off: null }
      }
      else this.$store.dispatch('discounts/discountShow', this.discountId)
    }
  }
</script>

<style lang="scss" scoped>

</style>
